import React from 'react';
import WordsAndSpelling from '../words-and-spelling';
import GraphicOrganizer from '../graphic-organizer';
import Vocabulary from '../vocabulary';
import Sentence from '../sentence';
import SequenceGraphicOrganizer from '../sequence-graphic-organizer';
import StoryOrganizer from '../story-organizer';
import MyOpinion from '../my-opinion';
import CompletionCertificate from '../completion-certificate';
import WordCards from '../word-cards';
import NameLabels from '../name-labels';
import NameTracing from '../name-tracing';
import { translate } from '../../translations/translator';
const t = key => translate('worksheet', key);

/** Key is sheetId */
const Map = {
  20: {
    name: 'wordsAndSpelling',
    Component: props => <WordsAndSpelling {...props} />
  },
  21: {
    name: 'vocabulary',
    Component: props => <Vocabulary {...props} />
  },
  211: {
    name: 'sentence',
    Component: props => <Sentence {...props} />
  },
  22: {
    name: 'sequenceGraphicOrganizer',
    Component: props => <SequenceGraphicOrganizer {...props} />
  },
  23: {
    name: 'graphicOrganizer',
    Component: props => <GraphicOrganizer {...props} />
  },
  24: {
    name: 'storyOrganizer',
    Component: props => <StoryOrganizer {...props} />
  },
  25: {
    name: 'myOpinion',
    Component: props => <MyOpinion {...props} />
  },
  251: {
    name: 'Word Cards',
    Component: props => <WordCards {...props} />
  },
  252: {
    name: 'Word Tags',
    Component: props => <NameLabels {...props} />
  },
  253: {
    name: 'Name Tags',
    Component: props => <NameTracing {...props} />
  },
  26: {
    name: 'certificateOfCompletionSwordfish',
    Component: props => (
      <CompletionCertificate
        {...props}
        images={[
          {
            name: 'swordfish',
            width: 600,
            height: 250,
            margin: '50px 0 0'
          }
        ]}
        completedTitle={t('printingPower')}
      />
    )
  },
  27: {
    name: 'certificateOfCompletionCrocodile',
    Component: props => (
      <CompletionCertificate
        {...props}
        images={[
          {
            name: 'crocodile',
            width: 600,
            height: 200
          }
        ]}
        completedTitle={t('myPrintingBook')}
      />
    )
  }
};

export default Map;
